/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CarrierCreditNoteState {
  Approved = "approved",
  Paid = "paid",
  Voided = "voided",
}

export function instanceOfCarrierCreditNoteState(value: any): boolean {
  for (const key in CarrierCreditNoteState) {
    if (Object.prototype.hasOwnProperty.call(CarrierCreditNoteState, key)) {
      if (
        CarrierCreditNoteState[key as keyof typeof CarrierCreditNoteState] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierCreditNoteStateFromJSON(
  json: any,
): CarrierCreditNoteState {
  return CarrierCreditNoteStateFromJSONTyped(json, false);
}

export function CarrierCreditNoteStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierCreditNoteState {
  return json as CarrierCreditNoteState;
}

export function CarrierCreditNoteStateToJSON(
  value?: CarrierCreditNoteState | null,
): any {
  return value as any;
}

export function CarrierCreditNoteStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierCreditNoteState {
  return value as CarrierCreditNoteState;
}
